module.exports = __webpack_public_path__ + "media/images/benefits_background-8db91f5e4a51c163e3a6ad10ea90022c.jpg";